import React, { useState } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import ProfileSection from "./ProfileSection/ProfileSection";
import dynamic from "next/dynamic";

const MonetizationDefaultForm = dynamic(
  () => import("./MonetizationSection/MonetizationDefaultForm"),
  {
    ssr: false,
  },
);
const Contactdetails = dynamic(() => import("./Contactdetails/Contactdetails"), {
  ssr: false,
});
const ProfileDetailSection = dynamic(() => import("./ProfileDetailSection/ProfileDetailSection"), {
  ssr: true,
});
const EditProfileSection = dynamic(() => import("./EditProfileSection/EditProfileSection"), {
  ssr: false,
});

const MonetizationAllSectionWrapper = (props) => {
  const [showMasonModal, setShowMasonModal] = useState(false);
  const showShareModal = (m) => {
    if (props.showShareModal) {
      props.showShareModal(m);
    }
  };
  const showRecommendationModal = (m) => {
    if (props.showRecommendationModal) {
      props.showRecommendationModal(m);
    }
  };
  const ask_a_question_modal = (m) => {
    if (props.ask_a_question_modal) {
      props.ask_a_question_modal(m);
    }
  };

  // eslint-disable-next-line complexity
  const {
    agentdetail,
    recommendationData,
    reviewData,
    hestiaData,
    hestiaInformation,
    showReviewModal,
    socialUpdateData,
    fetchCheckinsData,
    lang,
    langCode,
    profileData,
    query,
    clickDetectorAndScroll,
    clickDetectorData,
    socialloading,
    isUserLoggedIn,
    loginData,
  } = props;

  const agentBio = agentdetail && agentdetail.agent_bio;
  const personName = agentBio.person_name;
  const isProfileIncomplete = !personName || agentBio.has_photo === false || !agentBio.description;
  // const isProfileIncomplete =
  //   agentdetail &&
  //   agentdetail.agent_bio &&
  //   agentdetail.agent_bio.meta &&
  //   agentdetail.agent_bio.meta.completeness &&
  //   agentdetail.agent_bio.meta.completeness.percent_complete
  //     ? agentdetail.agent_bio.meta.completeness.percent_complete === 100
  //       ? false
  //       : true
  //     : true;
  return (
    <>
      <style jsx>{style}</style>
      <section className="preview-bottom-sheet-container" data-testid="component-allSectionWrapper">
        <div className="container">
          <div className="preview-main">
            <div className="aboutSectionWrapper">
              <div>
                <ProfileSection
                  {...props}
                  query={query}
                  agentdetail={agentdetail}
                  clickDetectorData={clickDetectorData}
                  clickDetectorAndScroll={clickDetectorAndScroll}
                  reviewData={reviewData}
                  showReviewModal={showReviewModal}
                  recommendationData={recommendationData}
                  ask_a_question_modal={() => ask_a_question_modal(props)}
                  showRecommendationModal={() => showRecommendationModal(props)}
                  lang={lang}
                  loginData={loginData}
                  isMonetizationProfile={true}
                  isProfileIncomplete={isProfileIncomplete}
                  isUserLoggedIn={isUserLoggedIn}></ProfileSection>
                <div className="contact-section">
                  {/* <hr className="section-divider" /> */}
                  <Contactdetails
                    profileData={profileData}
                    agentdetail={agentdetail}
                    query={query}
                    isUserLoggedIn={isUserLoggedIn}
                    loginData={loginData}
                    showShareModal={() => showShareModal(agentdetail)}
                    {...props}
                    lang={lang}></Contactdetails>
                </div>
                <ProfileDetailSection
                  socialloading={socialloading}
                  agentdetail={agentdetail}
                  profileData={profileData}
                  reviewData={reviewData}
                  recommendationData={recommendationData}
                  socialUpdateData={socialUpdateData}
                  fetchCheckinsData={fetchCheckinsData}
                  {...props}
                  hestiaData={hestiaData}
                  hestiaInformation={hestiaInformation}
                  showRecommendationModal={() => showRecommendationModal(props)}
                  ask_a_question_modal={() => ask_a_question_modal(props)}
                  monetization_modal={() => setShowMasonModal(true)}
                  showReviewModal={showReviewModal}
                  lang={lang}
                  langCode={langCode}
                  clickDetectorData={clickDetectorData}
                  isUserLoggedIn={isUserLoggedIn}
                  loginData={loginData}
                  isMonetizationProfile={props.isMonetizationProfile}
                  isProfileIncomplete={isProfileIncomplete}></ProfileDetailSection>
                {showMasonModal && (
                  <MonetizationDefaultForm
                    isDesktop={false}
                    showMasonModal={showMasonModal}
                    setCloseMasonModal={() => setShowMasonModal(false)}
                  />
                )}
                {!isProfileIncomplete && (
                  <EditProfileSection query={query} personName={personName} />
                )}
              </div>
              <div className="preview-main-content-form" data-testid="component-contactDetails">
                <div className="mason-web-monetization">
                  <MonetizationDefaultForm isDesktop={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default MonetizationAllSectionWrapper;

MonetizationAllSectionWrapper.defaultProps = {
  isMonetizationProfile: true,
};

MonetizationAllSectionWrapper.propTypes = {
  agentdetail: PropTypes.object,
  reviewData: PropTypes.array,
  socialUpdateData: PropTypes.array,
  fetchCheckinsData: PropTypes.array,
  recommendationData: PropTypes.array,
  teamProfileData: PropTypes.array,
  showShareModal: PropTypes.func,
  ask_a_question_modal: PropTypes.func,
  hestiaData: PropTypes.object,
  hestiaInformation: PropTypes.func,
  showRecommendationModal: PropTypes.func,
  showReviewModal: PropTypes.func,
  askaquestion: PropTypes.string,
  setRecommendationSuccess: PropTypes.func,
  setAskAQuestionSuccess: PropTypes.func,
  shareProfileSuccess: PropTypes.func,
  askaQuestionSuccess: PropTypes.string,
  recommendationSuccess: PropTypes.string,
  setReviewSuccess: PropTypes.func,
  reviewSuccess: PropTypes.string,
  shareStatus: PropTypes.string,
  lang: PropTypes.object,
  langCode: PropTypes.string,
  profileData: PropTypes.object,
  reviewRatingResponse: PropTypes.object,
  query: PropTypes.object,
  clickDetectorAndScroll: PropTypes.func,
  clickDetectorData: PropTypes.object,
  socialUpdatesOnClick: PropTypes.func,
  socialloading: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  loginData: PropTypes.object,
  isGoogleBot: PropTypes.bool,
  isMonetizationProfile: PropTypes.bool,
};
